import { Component, OnInit } from '@angular/core';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ViewAlertModal } from 'src/modules/features/setting/modals/app-security-modals/view-alert-modal/view-alert-modal.component';
import { AlertsService } from '../../services/alerts.service';
import { AppFilter } from '@app/shared/models';

@Component({
  selector: 'app-alert-scenarios',
  templateUrl: './alert-scenarios.component.html',
  styleUrls: ['./alert-scenarios.component.scss'],
})
export class AlertScenariosComponent implements OnInit {
  constructor(
    private modalService: SuiModalService,
    private alertService: AlertsService
  ) {}

  alertScenarios: any[] = [];
  filter = new AppFilter({ _search: false });
  pageChange: boolean;

  totalItems = 0;
  rows = 10;
  maxSize = 10;
  currentPage = 1;
  pending: boolean;
  success;
  error;
  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'alertScenario.alertScenarioName',
        op: 'cn',
        data: '',
      },
    ],
  };

  data = [
    {
      action: 'Failed Login Attempts',
      description: 'Real-time alerts for multiple failed login attempts',
    },
    {
      action: 'Failed Login Attempts',
      description: 'Real-time alerts for multiple failed login attempts',
    },
  ];

  getPage(pageNumber: number) {}

  nextPage(pageNumber: number) {
    this.filter.page = pageNumber;
    this.getAlerts();
    this.pageChange = true;
  }

  resetPageChange() {
    this.pageChange = false;
  }

  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: this.rows,
      _search: false,
    });

    this.getAlerts();
  }
  advancedSearch(e) {
    if (e) {
      this.filter._search = true;
      this.filter.filters = JSON.stringify(e);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.filter.page = 1;

    this.getAlerts();
  }

  filterSearch;

  sortRecords(search) {
    this.filter.sord = search;
    this.filter.page = 1;
    this.getAlerts();
  }

  headerFilters = [
    {
      field: 'status',
      label: 'status',
      type: 'select',
      op: 'eq',
      choices: [
        {
          optionId: 'INACTIVE',
          optionName: 'INACTIVE',
        },
        {
          optionId: 'ACTIVE',
          optionName: 'ACTIVE',
        },
      ],
      data: '',
    },
  ];
  headers = [
    {
      field: 'alertScenarioName',
      label: 'Action',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'status',
      label: 'Status',
      type: 'text',
      op: 'cn',
      data: '',
    },
  ];

  searchRecords(e) {
    this.searchFilter.rules[0].data = e;
    this.filter._search = true;

    this.filter.filters = JSON.stringify(this.searchFilter);
    this.filter.page = 1;
    this.getAlerts();
  }

  displayRecords(e) {
    this.filter['rows'] = e;
    this.currentPage = 1;

    this.getAlerts();
  }

  getAlerts() {
    this.pending = true;
    this.alertService.getAlerts(this.filter).subscribe(
      (res: any) => {
        this.totalItems = +res.records;
        this.alertScenarios = res.rows;
        this.getNotificationPreferences();
        this.pending = false;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
      }
    );
  }

  notificationPreferencesLoading = false;
  notificationPreferencesFilter = new AppFilter({ rows: 1000 });
  slackPreferences: any[] = [];
  emailPreferences: any[] = [];
  notificationPreferences: any[] = [];

  getNotificationPreferences() {
    this.notificationPreferencesLoading = true;
    this.alertService
      .getNotificationPreferences(this.notificationPreferencesFilter)
      .subscribe(
        (res: any) => {
          this.notificationPreferences = res.rows.map(
            (notificationPreference) => {
              let parsedPreference = JSON.parse(
                notificationPreference.settings
              );
              if (parsedPreference.notificationType === 'email') {
                this.emailPreferences.push({
                  settingId: notificationPreference.settingId,
                  ...parsedPreference,
                });
              } else if (parsedPreference.notificationType === 'slack') {
                this.slackPreferences.push({
                  settingId: notificationPreference.settingId,
                  ...parsedPreference,
                });
              }
              return {
                settingId: notificationPreference.settingId,
                ...parsedPreference,
              };
            }
          );

          for (let i = 0; i < this.alertScenarios.length; i++) {
            let alertConfiguration = JSON.parse(
              this.alertScenarios[i].configuration
            );
            let addendum = [];
            if (alertConfiguration?.notificationSettings.length) {
              for (
                let j = 0;
                j < alertConfiguration?.notificationSettings.length;
                j++
              ) {
                for (let k = 0; k < this.notificationPreferences.length; k++) {
                  if (
                    alertConfiguration?.notificationSettings[j] ===
                    this.notificationPreferences[k].settingId
                  ) {
                    addendum.push({
                      ...this.notificationPreferences[k],
                    });
                  }
                }
              }
            }
            this.alertScenarios[i] = {
              ...this.alertScenarios[i],
              notificationSettings: addendum,
            };
          }
        },
        (error) => {
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error.message
            ? error.message
            : error;
          this.notificationPreferencesLoading = false;
        }
      );
  }

  allUsersLoading = false;
  allUsers: any[] = [];
  allUsersFilter = new AppFilter({ rows: 1000000, _search: false });

  getAllUsers() {
    this.allUsersLoading = true;
    this.alertService.getUsersOnEservices(this.allUsersFilter).subscribe(
      (res: any) => {
        this.allUsers = res.rows;
        this.allUsersLoading = false;
      },
      (error) => {
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
        this.allUsersLoading = false;
      }
    );
  }

  deleteAlertEvent(alertId) {
    this.pending = true;
    this.alertService.deleteAlert(alertId).subscribe(
      (res) => {
        this.success = 'Alert deleted Successfully';
        this.pending = false;
      },
      (error) => {
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
        this.pending = false;
      }
    );
  }

  ngOnInit(): void {
    this.getAlerts();
    this.getAllUsers();
  }

  onSuccess(event: string) {
    this.success = event;
  }

  onError(event: string) {
    this.error = event;
  }
}
